import { gql } from '@apollo/client';

export const searchQuotesQueryForPPC = gql`
  query searchQuotesQueryForPPC($searchOptions: ConnectionSearchOptions, $filterOptions: FilterOption) {
    quotes(searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalCount
      nodes {
        id
        status
        quoteNumber
        name
        quoteContact
        quoteAuthor
        updatedBy
        createdDate
        expiryDate
        updatedDate
        billingGroupId
        total
        currency
        poNumber
        billToObject {
          companyName
        }
        shipToObject {
          id
          displayName
          addressLine1
          addressLine2
          city
          country
          postalCode
          state
        }
        createdBy {
          subject
        }
        updatedByObject {
          subject
        }
        metadata {
          quoteContact
          ecc_aaids
        }
        estimateLineItems {
          discountDetails {
            promotionId
            discountAmount
            percentOff
            reasonCode
            discountType
          }
          margins: marginDetails {
            promotionId
            amount
            percent
            reasonCode
            type
            promoCode
          }
        }
      }
    }
  }
`;
